<template>
  <div class="box">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="getOrderList">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="500"
      :show-footer="true"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      align="center"
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="transportType"
          show-header-overflow
          show-overflow
          title="订单类型"
          :formatter="formatterTransportType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.transportType"
            placeholder="--请选择--"
            clearable
          >
            <el-option
              v-for="item in formatterTransportTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 运单状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="status"
          show-header-overflow
          show-overflow
          title="运单状态"
          :formatter="formatterDetailStatus"
          min-width="130"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          show-header-overflow
          show-overflow
          title="运单号"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="relationNumber"
          show-header-overflow
          show-overflow
          title="订单号"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.relationNumber"
            placeholder="请输入订单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 运单图片 -->
      <vxe-table-column min-width="160" field="orderImage" title="运单图片">
        <template slot-scope="scope">
          <span class="btnPicture" @click="lookPicture(scope.row)"
            >查看图片</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          show-header-overflow
          show-overflow
          title="下单时间"
          min-width="420"
          sortable
          :resizable="false"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleNumber"
          show-header-overflow
          show-overflow
          title="接货车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleNumber"
            placeholder="接货车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleType"
          show-header-overflow
          show-overflow
          title="车型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleType"
            placeholder="输入车型"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cargoName"
          show-header-overflow
          show-overflow
          title="货物名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.cargoName"
            placeholder="输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cargoNumber"
          show-header-overflow
          show-overflow
          title="货物数量"
          min-width="160"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cargoNumberCompany"
          show-header-overflow
          show-overflow
          title="货物数量单位"
          min-width="160"
          sortable
          :formatter="formatterCargoNumberCompany"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          show-header-overflow
          show-overflow
          title="签收时间"
          min-width="420"
          sortable
          :resizable="false"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          show-header-overflow
          show-overflow
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          show-header-overflow
          show-overflow
          title="托运人电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadingPeople"
          show-header-overflow
          show-overflow
          title="发货方姓名"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadingPeople"
            placeholder="发货联系人"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="loadingPeoplePhone"
          show-header-overflow
          show-overflow
          title="发货方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadingPeoplePhone"
            placeholder="发货联系电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadingAddress"
          show-header-overflow
          show-overflow
          title="发货方地址"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadingAddress"
            placeholder="发货联系人地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryName"
          show-header-overflow
          show-overflow
          title="收货方姓名"
          min-width="140"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.deliveryName"
            placeholder="发货联系人"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="deliveryPhone"
          show-header-overflow
          show-overflow
          title="收货方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.deliveryPhone"
            placeholder="发货联系电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryAddress"
          show-header-overflow
          show-overflow
          title="收货方地址"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadingAddress"
            placeholder="收货方地址"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          show-header-overflow
          show-overflow
          title="装货时间"
          min-width="420"
          sortable
          :resizable="false"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          show-header-overflow
          show-overflow
          title="集货时间"
          min-width="420"
          sortable
          :resizable="false"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="upstreamCost"
          show-header-overflow
          show-overflow
          title="上游运费"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.upstreamCost"
            placeholder="上游运费"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 上游运费结算方式 -->
      <vxe-table-column>
        <vxe-table-column
          field="paymentType"
          show-header-overflow
          show-overflow
          title="上游运费结算方式"
          :formatter="formatterDeliveryFeeType"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paymentType"
            placeholder="--请选择--"
            clearable
          >
            <el-option
              v-for="item in deliveryFeeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverFreight"
          show-header-overflow
          show-overflow
          title="司机运费"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverFreight"
            placeholder="司机运费"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="collectionDelivery"
          show-header-overflow
          show-overflow
          title="代收款"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.collectionDelivery"
            placeholder="代收款"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="paymentType"
          show-header-overflow
          show-overflow
          title="代收款结算方式"
          :formatter="formatterPaymentType"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.deliveryFeeType"
            placeholder="--请选择--"
            clearable
          >
            <el-option
              v-for="item in formatterPaymentTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isClearing"
          show-header-overflow
          show-overflow
          title="清分结算状态"
          min-width="120"
          sortable
        />
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isImportOrder"
          :formatter="formatterisImportOrder"
          show-header-overflow
          show-overflow
          title="是否批量导入"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isImportOrder"
            placeholder="--请选择--"
            clearable
          >
            <el-option
              v-for="item in formatterisImportOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="130" title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-show="scope.row.buttons.particularsCargoShow"
            class="item"
            effect="dark"
            content="货物详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-show="scope.row.buttons.orderDetailShow"
            class="item"
            effect="dark"
            content="运单跟踪"
            placement="top"
          >
            <vxe-button type="text" @click="orderROuter(scope.row)">
              <i class="el-icon-position" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="pictureShow"
      :lock-scroll="false"
      width="500"
      height="400"
      title="查看图片"
      resize
    >
      <viewPicture ref="pictureRef" />
    </vxe-modal>
    <!-- 弹窗功能 -->
    <vxe-modal
      v-model="modelDetailFlag"
      title="货物详情"
      center
      width="500"
      height="400"
      resize
    >
      <orderDetail ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelRouterFlag"
      title="运单跟踪"
      width="60%"
      height="600"
      resize
    >
      <orderRouter ref="routerRef" />
    </vxe-modal>
  </div>
</template>
<script>
import orderDetail from "./components/orderDetail.vue";
import orderRouter from "./components/orderRouter.vue";
import viewPicture from "./components/viewPicture.vue";
import { ajax } from "@/api/ctms";
export default {
  name: "WaybillManagement",
  components: {
    orderDetail,
    orderRouter,
    viewPicture
  },
  data() {
    return {
      loading: false,
      modelDetailFlag: false,
      modelRouterFlag: false,
      pictureShow: false,
      tableData: [],
      Pagingconf: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        sortField: "",
        sortType: "",
        total: 0,
        code: ""
      },
      formatterDetailStatusOptions: [
        { label: "未接单", value: 0, color: "gray" },
        { label: "已接单", value: 1, color: "#0000ff" },
        { label: "已运输", value: 2, color: "#ff0000" },
        { label: "已签收", value: 3, color: "#00bd93" },
        { label: "已取消", value: 4, color: "#00bd93" },
        { label: "异常运单", value: 5, color: "#00bd93" },
        { label: "取货失败", value: 6, color: "#00bd93" },
        { label: "送货失败", value: 7, color: "#00bd93" }
      ],
      deliveryFeeTypeOptions: [
        { label: "发货联系人现金支付", value: 0, color: "gray" },
        { label: "卸货联系人现金支付", value: 1, color: "#0000ff" },
        { label: "发货联系人在线支付", value: 2, color: "#ff0000" },
        { label: "卸货联系人在线支付", value: 3, color: "#00bd93" },
        { label: "发货联系人月结", value: 4, color: "#00bd93" },
        { label: "卸货联系人月结", value: 5, color: "#00bd93" }
      ],
      formatterTransportTypeOptions: [
        { label: "零担", value: 1, color: "gray" },
        { label: "包车", value: 0, color: "#0000ff" }
      ],
      formatterPaymentTypeOptions: [
        { label: "到付", value: 0, color: "gray" },
        { label: "现付", value: 1, color: "#0000ff" }
      ],
      formatterIsClearingOptions: [
        { label: "未清分", value: 0, color: "gray" },
        { label: "已申请", value: 1, color: "#0000ff" },
        { label: "已驳回", value: 2, color: "#0000ff" },
        { label: "已清分", value: 3, color: "#0000ff" },
        { label: "清分失败", value: 4, color: "#0000ff" }
      ],
      formatterisImportOrderOptions: [
        { label: "否", value: 0, color: "gray" },
        { label: "是", value: 1, color: "#0000ff" }
      ],
      sumFee: {},
      // 审核状态
      authStatusOptions: [
        { label: "未审核", value: 0, color: "gray" },
        { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      // 通用是否状态
      commonStatusOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      cargoNumberCompanyOptions: [
        { label: "千克", value: "0" },
        { label: "件", value: "1" },
        { label: "方", value: "3" }
      ]
    };
  },
  created() {
    this.WaybillManagementList(this.listQuery.orderRelationCode);
  },
  methods: {
    async RefreshList() {
      this.listQuery = {
        orderRelationCode: this.listQuery.orderRelationCode,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      };
      await this.WaybillManagementList();
    },
    WaybillManagementList(code) {
      if (code) {
        this.listQuery.orderRelationCode = code;
      }
      ajax(
        "/ntocc-ctms-api/ctmsOrderDetail/charterOrderDetailList",
        "get",
        this.listQuery
      )
        .then(data => {
          this.listQuery.total = data.data.total;
          this.tableData = data.data.records;
          this.sumFee = data.mapFee;
          this.loading = false;
          data.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, data.data.total]);
          for (const item in this.tableData) {
            if (
              this.tableData[item].isSettle != 1 ||
              this.tableData[item].isBalance != 1
            ) {
              this.tableData[item].isClearing = "未结算";
            } else {
              this.tableData[item].isClearing = "已结算";
            }
            // var buttons = {}
            var particularsCargoShow = true;
            var orderDetailShow = true;
            this.tableData[item]["buttons"] = {
              particularsCargoShow: particularsCargoShow,
              orderDetailShow: orderDetailShow
            };
          }
        })
        .catch(error => {
          // console.log(error)
        });
    },
    // 排序
    sortList({ column, property, order }) {
      this.listQuery.sortField = property;
      this.listQuery.sortType = order;
      this.WaybillManagementList();
    },
    lookPicture(row) {
      this.$refs.pictureRef.getInfo(
        row.fillImageUrl,
        row.signImageUrl,
        row.ticketImageUrl
      );
      this.pictureShow = true;
    },
    // 查询
    getOrderList() {
      this.listQuery.pageNum = 1;
      this.WaybillManagementList(this.listQuery.orderRelationCode);
    },
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.WaybillManagementList();
    },
    //  // 在值发生改变时更新表尾合计
    updateFooterEvent(params) {
      const xTable = this.$refs.xTable;
      xTable.updateFooter();
    },

    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          /* if (['upstreamCost', 'collectionDelivery', 'driverFreight'].includes(column.property)) {
              return XEUtils.sum(data, column.property)
          }*/
          if (column.property === "upstreamCost") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "collectionDelivery") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "driverFreight") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    orderDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    orderROuter(row) {
      const loadingLnglatArry = row.loadingLnglat.split(",");
      if (loadingLnglatArry.length > 1) {
        this.$refs.routerRef.loadingLongitude = loadingLnglatArry[0];
        this.$refs.routerRef.loadingLatitude = loadingLnglatArry[1];
      }
      this.$refs.routerRef.deliveryLongitude = row.deliveryLongitude;
      this.$refs.routerRef.deliveryLatitude = row.deliveryLatitude;
      this.$refs.routerRef.getInfo(row.code);
      this.modelRouterFlag = true;
    },
    formatterTransportType({ cellValue }) {
      const item = this.formatterTransportTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterDetailStatus({ cellValue }) {
      const item = this.formatterDetailStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterIsClearing({ cellValue }) {
      const item = this.formatterIsClearingOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterisImportOrder({ cellValue }) {
      const item = this.formatterisImportOrderOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterCargoNumberCompany({ cellValue }) {
      const item = this.cargoNumberCompanyOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterPaymentType({ cellValue }) {
      const item = this.formatterPaymentTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 上游运费结算方式
    // formatterDeliveryFeeType({ cellValue }) {
    //   switch (cellValue) {
    //     case 0:
    //       return '发货联系人现金支付'
    //       break
    //     case 1:
    //       return '卸货联系人现金支付'
    //       break
    //     case 2:
    //       return '发货联系人在线支付'
    //       break
    //     case 3:
    //       return '卸货联系人在线支付'
    //       break
    //     case 4:
    //       return '发货联系人月结'
    //       break
    //     case 5:
    //       return '卸货联系人月结'
    //       break
    //     default:
    //       break
    //   }
    // },
    formatterDeliveryFeeType({ cellValue }) {
      const item = this.deliveryFeeTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    }
  }
};
</script>

<style>
.vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 6px 0;
}
.vxe-toolbar {
  padding: 0 0 10px 0;
}
.box {
  padding: 10px 20px;
}
.queryMainBtn {
  width: 80px;
  margin: -5px 0 0 -50px;
  font-weight: bold;
}
.btnPicture {
  min-width: 140px;
  line-height: 40px;
  background: #1890ff;
  border-radius: 4px;
  padding: 10px 20px;
  font-family: PingFang SC;
  color: #ffffffff;
  cursor: pointer;
}
/* .vxe-cell--title ::v-deep .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 240px;
}
 ::v-deep.el-date-editor .el-range-separator {
    width: 12%;
}
::v-deep .el-date-editor .el-range-input {
  width:43%;
} */
</style>
